export default "__VITE_ASSET__BKW8uyf9__"